export default "/img/UY.70ab05c1dc7af0cd4db0e29110c6ac0c.png";